import { useLocalStorage } from '@/hooks/useStorage';
import { useReq } from '@/services/net/request';
import { history, useModel } from '@@/exports';
import usePageRefreshOnVisible from '@/hooks/usePageRefreshOnVisible';
import { useEffect, useState } from 'react';
import { GetCoinListTypeEnum, ContractListTypeEnum, WalletTypeEnum } from '@/enums/businessEnum';
import { useDebounceFn, useUpdateEffect } from 'ahooks';
import PageEnum from '@/enums/pageEnum';
import { getTradingSymbolsApi } from '@/services/api/requestApi';

export default ({
                  localCacheKey,
                  localListCacheKey,
                  type,
                  contractType,
                  disable = false,
                }: {
  localCacheKey: string
  localListCacheKey: string
  type: GetCoinListTypeEnum
  contractType?: ContractListTypeEnum
  disable?: boolean
}) => {
  const { sendMsg, isSub, socketId } = useModel('socket');
  const { user } = useModel('user');
  const pageKey = usePageRefreshOnVisible();
  const [loading, setLoading] = useState(false);
  // 使用本地存储钩子来管理股票信息
  const [localCoin, setLocalCoin] = useLocalStorage({
    key: localCacheKey,
    defaultValue: null,
  });
  const [localList = [], setLocalList] = useLocalStorage({
    key: localListCacheKey,
    defaultValue: [],
  });
  // 异步获取合约缓存进本地
  const { runAsync: getList, loading: localListLoading } = useReq(
    getTradingSymbolsApi,
    {
      loadingDefault: false,
      manual: true,
      ready: !disable,
      formatResult: (res: any) => {
        const { list } = res?.data || [];
        return list ?? [];
      },
      onSuccess: (res: any) => {
        // 成功获取数据后，更新本地存储和发送订阅消息
        if (res?.[0]) {
          if (!localCoin) {
            setLocalCoin(res[0]);
          }
          sendMsg(
            `{"type":"SUB","data": ${JSON.stringify(
              res?.map((i: { symbol: any }) => i?.symbol),
            )}}`,
          );
        }
      },
    },
  );
  useEffect(() => {
    // 合约列表为空不执行
    if (!localList?.length) return;
    // 订阅当前列表
    sendMsg(
      `{"type":"SUB","data": ${JSON.stringify(
        localList?.map((i: { symbol: any }) => i?.symbol),
      )}}`,
    );
    // 如果没有选择过合约
    if (!localCoin?.id) {
      setLocalCoin(localList[0]);
    }
  }, [localList, pageKey, isSub]);

  const updateLocal = async (symbol: any) => {
    if (symbol && user?.id) {
      const data: any = await getTradingSymbolsApi({
        pageNo: 1,
        pageSize: 15,
        type: type,
        contractType,
        symbol: symbol,
      });
      if (data?.code === 0) {
        const newData = data?.data?.list?.[0];
        setLocalCoin(newData);
      }
    }
  };


  const { run: fetchList } = useDebounceFn(
    async (params: any) => {
      try {
        setLoading(true);
        const res = await getList(params);
        setLocalList(res);
      } finally {
        setLoading(false);
      }
    },
    { wait: 1000 },
  );

  useEffect(() => {

    if (socketId && !localList?.length) {
      fetchList({
        pageNo: 1,
        pageSize: 15,
        type,
      });
    }
  }, [socketId, localList?.length, type]);

  useUpdateEffect(() => {
    fetchList({
      pageNo: 1,
      pageSize: 15,
      type,
      contractType,
    });

  }, [type]);

  // 点击币种
  const onContractCoinClick = ({
                                 item,
                                 isCollect = false,
                                 onClickItem,
                                 getCoinListType,
                               }: {
    item: any
    getCoinListType: GetCoinListTypeEnum
    isCollect?: boolean
    onClickItem?: (item: any) => void
  }) => {
    if (isCollect) {
      setLocalCoin({
        ...item,
        id: item?.sourceId,
      });
    } else {
      setLocalCoin(item);
    }
    history.push(`${PageEnum.CONTRACT}?type=${getCoinListType}`);
    //便于扩展
    onClickItem?.(item);
    // 更新缓存
    updateLocal(item?.symbol);
  };

  return {
    localCoin,
    setLocalCoin,
    localList,
    setLocalList,
    localListLoading,
    fetchList,
    updateLocal,
    isSub,
    socketId,
    pageKey,
    loading,
    getList,
    onContractCoinClick,
  };
}